import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

interface Programme { id: string; nom: string; statut: string; lien_trace: string }

/** Fiche client du CRM : crée la recommandation et prépare le message avec le lien traqué. Rien n'est envoyé automatiquement. */
export default function RecommanderPartenaire({ contactId }: { contactId: string }) {
  const [programmes, setProgrammes] = useState<Programme[]>([]);
  const [choix, setChoix] = useState("");
  const [message, setMessage] = useState("");
  const [occupe, setOccupe] = useState(false);

  useEffect(() => {
    fetch(`${BACKEND}/api/affiliation/programmes`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : { programmes: [] }))
      .then((d) => setProgrammes((d.programmes || []).filter((p: Programme) => p.statut === "accepte" && p.lien_trace)))
      .catch(() => setProgrammes([]));
  }, [contactId]);
  useEffect(() => { setMessage(""); }, [contactId]);

  const recommander = async () => {
    if (!choix) return toast.error("Choisissez un partenaire");
    setOccupe(true);
    try {
      const r = await fetch(`${BACKEND}/api/affiliation/recommander`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ programme_id: choix, contact_id: contactId }) });
      const d = await r.json().catch(() => ({}));
      if (r.ok) { setMessage(d.message_pret); toast.success("Recommandation enregistrée, message prêt"); }
      else toast.error(typeof d.detail === "string" ? d.detail : "Recommandation impossible");
    } finally { setOccupe(false); }
  };

  return (
    <div className="border border-border/40 rounded-lg p-3 space-y-2" data-testid="recommander-partenaire">
      <p className="text-xs text-muted-foreground">Recommander un partenaire</p>
      {programmes.length === 0 ? (
        <p className="text-xs text-muted-foreground">Aucun programme accepté avec un lien pour l'instant (Qonto : candidature en attente).</p>
      ) : (
        <div className="flex gap-2">
          <select className="border rounded-md bg-background px-2 h-9 text-sm flex-1" value={choix} onChange={(e) => setChoix(e.target.value)}>
            <option value="">Choisir…</option>{programmes.map((p) => <option key={p.id} value={p.id}>{p.nom}</option>)}
          </select>
          <Button size="sm" disabled={occupe} onClick={recommander}>Préparer le lien</Button>
        </div>
      )}
      {message && (
        <div className="space-y-2">
          <textarea className="w-full border rounded-md bg-background p-2 text-sm" rows={6} value={message} onChange={(e) => setMessage(e.target.value)} />
          <Button size="sm" variant="outline" onClick={async () => { try { await navigator.clipboard.writeText(message); toast.success("Message copié"); } catch { toast.error("Copie impossible"); } }}>Copier le message</Button>
        </div>
      )}
    </div>
  );
}
